const anreden = [
    { value: 'Herr', text: 'Herr' },
    { value: 'Frau', text: 'Frau' }
]

export default anreden;